import { cn } from '@folio/lib';

type StatusPillProps = {
  color?: string;
  label: string;
};

export const StatusPill = ({ color = 'bg-gray-100 text-gray-700', label }: StatusPillProps) => (
  <div className={cn(color, 'w-fit px-4 py-1 rounded-full text-xs font-semibold uppercase')}>
    {label}
  </div>
);
